const CashTransferTypeEnum = Object.freeze({
	WITHDRAWAL_FROM_VAULT: 'WithdrawalFromVault',
	WITHDRAWAL_FROM_BANK: 'WithdrawalFromBank',
	DEPOSIT_TO_VAULT: 'DepositToVault',
	DEPOSIT_TO_BANK: 'DepositToBank',
	BETWEEN_COLLECTORS: 'BetweenCollectors',
	RT_FILL: 'RtFill',
});

export default CashTransferTypeEnum;
